<template>
    <v-card>
        <v-card-text>
            <template v-if="coursesFetched">
                <template v-if="courses.length > 0">
                    <p v-html='$t("LTI_SELECT_STEP_TEXT", {canvasCourseName})' />
                    <v-select v-model="selectedCourse" :items="courses" item-text="name"  :return-object="true" :label="$t('LTI_SELECT_SELECT_COURSE_LABEL')" :loading="fetchingCourses" :disabled="isLoading || fetchingCourses">
                        <template slot="item" slot-scope="data">
                            <v-list-item-content>
                                <v-list-item-title>{{data.item.name}}</v-list-item-title>
                                <v-list-item-subtitle class="caption grey--text text--darken-1">{{getCourseInstructors(data.item)}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-select>
                </template>
                <template v-else>
                    <p v-html='$t("LTI_SELECT_NO_COURSES", {canvasCourseName})' />
                </template>
            </template>
            <template v-else>
                <loading :message="$t('LTI_SELECT_LOADING')" />
            </template>
        </v-card-text>
        <v-card-actions class="pl-2 pr-3 pb-3">
            <v-spacer></v-spacer>
            <v-btn color="confirm" text @click="cancel" :disabled="isLoading">
                {{ $t("LTI_SELECT_STEP_CANCEL") }}
            </v-btn>
            <v-btn color="primary" class="elevation-0" @click="confirm" :disabled="isLoading || fetchingCourses || !selectedCourse.id">
                {{ $t("LTI_SELECT_STEP_CONFIRM") }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { Component, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import { CourseFilter, CourseStatus, ICourse} from "@cyber-range/cyber-range-api-user-client";
import Loading from '@utils/Loading.vue';
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";
import { useAuthorizationStore } from "@/stores/authorizationStore";
import { useErrorStore } from "@/stores/errorStore";

@Component({components: {Loading}})
export default class SelectStep extends Vue {

    @Prop(Boolean) active:boolean;
    get isLoading() { return useApiClientStore().isLoading; }
    get userApiClient() { return useApiClientStore().userApiClient; }
    get ltiIdentity() { return useAuthenticationStore().ltiIdentity; }
    canCreateCourseApplication = useAuthorizationStore().canCreateCourseApplication;

    courses:ICourse[] = [];
    selectedCourse:ICourse = <ICourse>{};
    fetchingCourses:boolean = false;
    coursesFetched:boolean = false;

    get canvasCourseName():string
    {
        return this.ltiIdentity['contextName']
    }

    @Watch("active", {immediate: true})
    async onActiveChanged()
    {
        if(this.active)
        {
            this.courses = [];
            this.selectedCourse = <any>{}

            try
            {
                this.coursesFetched = false;
                this.fetchingCourses = true;
                // TEMPORARY LOG
                console.log('[SelectStep] Fetching courses for organizationId:', this.ltiIdentity.organizationId, 'and userId:', this.ltiIdentity.userId);
                let filter = new CourseFilter({organizationIds: [this.ltiIdentity.organizationId]})
                this.courses = (await this.userApiClient.getAllCourses(filter))
                                                        .sort((a,b)=>a.name.localeCompare(b.name, undefined, { sensitivity: "base", numeric: true }))
                                                        .filter(course => this.canCreateCourseApplication(course.id, course.organizationId) && course.status === CourseStatus.Ready)

                this.coursesFetched = true;

                // TEMPORARY LOG
                console.log('[SelectStep] Fetched courses:', this.courses);
            }
            catch (error)
            {
                // TEMPORARY LOG
                console.error('[SelectStep] Failed to load courses:', error);
                useErrorStore().setError(error);
            }
            finally
            {
                this.fetchingCourses = false;
            }
        }
    }

    getCourseInstructors(course:ICourse): string
    {
        return (course.statistics?.instructors || []).map(instructor => instructor.name).join(', ')
    }
    
    cancel()
    {
        this.$emit('cancel')
    }

    confirm()
    {
        this.$emit('confirm', this.selectedCourse)
    }
}
</script>
